const locale = {
    placeholder: 'を',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/ja_JP.tsx